/*=========================================================================================
  File Name: module-outinvoice-actions.js
  Description: OutInvoice Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import OutInvoiceAPI from '@/api/OutInvoiceAPI.js';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';

export default {
	/**
	 * Lấy danh sách hóa đơn đầu ra theo paging
	 */
	loadOutInvoices: async function(context, payload) {
		let res = await httpClient.getAsync(
			{ url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/v2`, params: payload },
			true
		);
		if (res && res.Success) {
			context.commit('updateOutInvoices', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	/**
	 * Lấy danh sách hóa đơn đầu ra theo paging
	 */
	loadOutInvoicesElastic: async function(context, payload) {
		let res = await httpClient.postAsync(
			{ url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/v3`, data: payload },
			true
		);
		if (res && res.Success) {
			context.commit('updateOutInvoices', { data: res.Data, isGetTotal: payload.IsGetTotal });
		}
		return null;
	},

	/**
	 * Xóa và khôi phục hóa đơn
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	deleteAndRestoreOutInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/trash`,
				params: payload
			},
			true
		);
		return res;
	},

	restoreOutInvoicesAsync: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/restore`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Xóa và khôi phục nhiều hóa đơn
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	deleteOutInvoices: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/trashs`,
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Lấy chi tiết hóa đơn đầu ra
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getOutInvoiceById: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}`
			},
			true
		);

		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Di chuyển hóa đơn
	 */
	moveOutInvoice: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/move`,
				data: payload
			},
			true
		);
		return res;
	},

	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	},

	getTotalPageV3Async: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/totalv3`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	},

	/**
	 * Kiểm tra lại hàng loạt hóa đơn đầu ra
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	checkAgain: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checkagain`,
				data: payload,
				timeout: window.__env.appSetting.timeoutCheckAgain
			},
			true
		);
		return res;
	},

	/**
	 * Cập nhật trạng thái đã xem/chưa xem cho danh sách hóa đơn đầu ra
	 * @param {*} context
	 * @param {*} payload {ListInvoiceId, Status}
	 * @returns
	 */
	updateStatusViewOutInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/viewed`,
			data: payload,
		});
		return res;
	},

	/**
	 * Lấy tổng tiền chân trang hóa đơn đầu ra
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalAmountPageAsync: async function(context, payload) {
		//PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
		context.commit('updateLoadingTotalAmountPage', true, {
			root: true
		});
		let res = await httpClient.postAsync(
			{ url: `${OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totalamountpage`, data: payload },
			false
		);
		context.commit('updateLoadingTotalAmountPage', false, {
			root: true
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy tổng tiền chân trang hóa đơn đầu ra
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalAmountPageV3Async: async function(context, payload) {
		//PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
		context.commit('updateLoadingTotalAmountPage', true, {
			root: true
		});
		let res = await httpClient.postAsync(
			{ url: `${OutInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totalamountpagev3`, data: payload },
			false
		);
		context.commit('updateLoadingTotalAmountPage', false, {
			root: true
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Cập nhật chi tiết hóa đơn từ cơ quan thuế
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	updateInvoiceDetailFromTaxaxionAgain: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${OutInvoiceAPI.getAPIUrlSubParam(
					commonFunc.getSubParam()
				)}/updateinvdetailfromtaxaxionagainmany`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	}
};
